export enum SuperScoreArea {
  NominatedBeneficiary = "Nominated Beneficiary",
  LifeInsurance = "Life Insurance",
  InvestmentApproach = "Investment Approach",
  AccountBalance = "Account Balance",
  RetirementAdequacy = "Retirement Adequacy",
}
